import React from 'react';
import './header.css';

const Header = () => {
  return (
    <div className="anodos__header section__padding">
      <div className="anodos__header-content">
        <h1>Ανακοινώσεις</h1>
      </div>
    </div>
  )
}

export default Header